import type { Messages } from '../i18n/messages';

export const securityMessages: Messages = {
  'security.entityContent.title': { en: 'Security', fun: 'Vuln Patrol' },
  'security.dependabotAlerts.filterAriaLabel': {
    en: 'Alert state',
    fun: 'Bug status',
  },
  'security.dependabotAlerts.filterAll': { en: 'ALL', fun: 'ALL' },
  'security.dependabotAlerts.filterOpen': { en: 'OPEN', fun: 'OPEN' },
  'security.dependabotAlerts.filterFixed': { en: 'FIXED', fun: 'SQUASHED' },
  'security.dependabotAlerts.filterDismissed': {
    en: 'DISMISSED',
    fun: 'YEETED',
  },
  'security.dependabotAlerts.refreshTooltip': {
    en: 'Refreshes Dependabot alerts now. Auto refresh runs every 5 minutes while this tab is visible and pauses when the browser tab is hidden.',
    fun: 'Zaps in fresh Dependabot alerts right now. Auto-zap runs every 5 minutes while this tab is open, and naps the moment it is hidden.',
  },
  'security.dependabotAlerts.truncated': {
    en: 'More than {cap} alerts match this filter — showing the first {cap}.',
    fun: 'More than {cap} bugs match this filter — flexing the first {cap} of them.',
  },
  'security.dependabotAlerts.searchAriaLabel': {
    en: 'Search',
    fun: 'Bug hunt',
  },
  'security.dependabotAlerts.searchPlaceholder': {
    en: 'Search alerts',
    fun: 'Hunt for bugs',
  },
  'security.dependabotAlerts.columnName': { en: 'Name', fun: 'Culprit' },
  'security.dependabotAlerts.columnCreated': { en: 'Created', fun: 'Spotted' },
  'security.dependabotAlerts.columnState': { en: 'State', fun: 'Status' },
  'security.dependabotAlerts.columnSeverity': {
    en: 'Severity',
    fun: 'Danger level',
  },
  'security.dependabotAlerts.columnPatched': {
    en: 'Patched Version',
    fun: 'Fixed in',
  },
  'security.dependabotAlerts.connectTitle': {
    en: 'GitHub authorization needed',
    fun: 'GitHub wants a handshake',
  },
  'security.dependabotAlerts.connectDescription': {
    en: 'Dependabot alerts are read with your own GitHub session. Connect once to load them.',
    fun: 'Bug reports come straight from your own GitHub session. Shake hands once and they flow.',
  },
  'security.dependabotAlerts.connectButton': {
    en: 'Connect GitHub',
    fun: 'Link up GitHub',
  },
  'security.dependabotAlerts.emptyTitle': { en: 'No alerts', fun: 'All clear' },
  'security.dependabotAlerts.emptyDescription': {
    en: 'No Dependabot alerts match the current filter.',
    fun: 'Not a single bug matches this filter. Nice.',
  },
};
